import {
    isOrgPerUrlEnabled,
    isOrgUiEnabled,
} from '@thoughtspot/session-service';
import { Applications } from '../../../routing/routes';
import { removeOverrideOrgId } from '../../../services/system/nav-service/nav-service';

/**
 * Constructs the admin URL with the org override removed when needed
 * (for use with window.open when opening in new tab)
 */
const getAdminUrlWithoutOrgOverride = (): string => {
    const baseUrl = `${window.location.href.split('#')[0]}#/admin`;
    return removeOverrideOrgId(baseUrl);
};

/**
 * Navigates to admin using window.location.replace to force page reload
 * and reset session context to primary org
 */
const navigateToAdminWithCleanUrl = (): void => {
    const currentPathBeforeHash = `${window.location.href.split('#')[0]}#`;
    let path = `${currentPathBeforeHash}/admin`;
    path = removeOverrideOrgId(path);
    // Force page reload to reset session context
    window.location.replace(path);
};

export const goToApplicationHome = (
    applicationID: string,
    navService: { goToUrl: (url: string) => void },
    event: React.MouseEvent,
): void => {
    if (event.metaKey || event.ctrlKey) {
        if (applicationID === Applications.INSIGHTS) {
            window.open('#/insights/home', '_blank');
        } else if (applicationID === Applications.DATA) {
            window.open('#/data/tables', '_blank');
        } else if (applicationID === Applications.DEVELOP) {
            window.open('#/develop', '_blank');
        } else if (applicationID === Applications.ADMIN) {
            // When Per Org URL feature is enabled, remove overrideOrgId from URL
            // when navigating to Admin, as Admin should always operate in the
            // context of the current session org, not the URL override org
            if (isOrgUiEnabled() && isOrgPerUrlEnabled()) {
                window.open(getAdminUrlWithoutOrgOverride(), '_blank');
            } else {
                window.open('#/admin', '_blank');
            }
        }
        return;
    }

    if (applicationID === Applications.INSIGHTS) {
        navService.goToUrl('/insights/home');
    } else if (applicationID === Applications.DATA) {
        navService.goToUrl('/data/tables');
    } else if (applicationID === Applications.DEVELOP) {
        navService.goToUrl('/develop');
    } else if (applicationID === Applications.ADMIN) {
        // When Per Org URL feature is enabled, remove overrideOrgId from URL
        // when navigating to Admin, as Admin should always operate in the
        // context of the current session org, not the URL override org
        if (isOrgUiEnabled() && isOrgPerUrlEnabled()) {
            navigateToAdminWithCleanUrl();
        } else {
            navService.goToUrl('/admin');
        }
    }
};
